import { actions as ACCOUNTS } from "@src/Actions/Reducers/AccountsReducer"
import { Section } from "@src/Components/StyledUtils"
import C from "@src/Controller"
import { tState } from "@src/Model/Model"
import { colors } from "@src/theme"
import { Button, Typography } from "@zeguro/component-library"
import * as React from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"

export const CheckYourEmail = () => {
  const dispatch = useDispatch()
  const email = useSelector(
    (state: tState) => state?.account?.sendResetPasswordMagicLink?.email,
  )

  const clearResetPasswordMagicLink = () => {
    dispatch(ACCOUNTS.sendResetPasswordMagicLinkClear())
  }

  return (
    <Section padding="0 100">
      <Row>
        <Typography
          variant="heading1"
          align="center"
          margin="20px 0px"
          color={colors.darkBlue}
        >
          Check your email.
        </Typography>
      </Row>
      <Row>
        <Typography variant="body1" margin="0 0 20px 0" color={colors.black50}>
          If an account exists, an email with a recovery link <br />
          will be sent you
          <span
            dangerouslySetInnerHTML={{
              __html:
                email && email !== ""
                  ? ` at <b>${email.toLowerCase()}</b>`
                  : "",
            }}
          />
          .
        </Typography>
      </Row>
      <Row>
        <Icon src="images/icon_email_verified.svg" />
      </Row>
      <br />
      <Row>
        <HeadingGray>Didn&apos;t receive an email?</HeadingGray>
      </Row>
      <br />
      <Row>
        <Typography variant="body1" margin="0 0 20px 0" color={colors.black50}>
          It may take a couple of minutes to arrive in your inbox.
          <br /> Please check your spam or junk folder if you don&apos;t see it.
        </Typography>
      </Row>
      <Row>
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => {
              C.showSupportModal()
            }}
            id="contact-support-button"
            width="170px"
            margin="10px"
          >
            Contact Support
          </Button>
        </ButtonContainer>
      </Row>
      <Row>
        <FooterText>
          Or&nbsp;
          <Button
            variant="tertiary"
            onClick={() => {
              clearResetPasswordMagicLink()
            }}
          >
            use another email address instead.
          </Button>
        </FooterText>
      </Row>
    </Section>
  )
}

const Row = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const Icon = styled.img`
  width: 110px;
`

const FooterText = styled.p`
  margin-top: 20px;
  font-size: 15px;
  line-height: 21px;
`

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
`

const HeadingGray = styled.div`
  font-family: proxima-nova, sans-serif;
  font-size: 18px;
  color: #6f7379;
  text-align: center;
  width: 100%;
  font-weight: bold;
`
